
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.js-giftcard-form').forEach(function (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault(); // ingen redirect

          var button = form.querySelector('.giftcard-box__icon-button');
          var formData = new FormData(form);

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          })
          .then(function (response) {
            if (!response.ok) throw new Error(response.statusText);
            return response.json();
          })
          .then(function (data) {
            // 1) visuel feedback på knappen
            if (button) {
              button.textContent = '✓';
              button.classList.add('giftcard-box__icon-button--added');
              setTimeout(function () {
                button.textContent = '+';
                button.classList.remove('giftcard-box__icon-button--added');
              }, 1500);
            }

            // 2) opdater cart count i header
            fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (res) { return res.json(); })
              .then(function (cart) {
                var bubbles = document.querySelectorAll('.cart-count-bubble, [data-cart-count]');
                bubbles.forEach(function (bubble) {
                  // Dawn bruger lidt forskellige strukturer alt efter version
                  if (bubble.querySelector('span')) {
                    bubble.querySelector('span').textContent = cart.item_count;
                  } else {
                    bubble.textContent = cart.item_count;
                  }
                  bubble.classList.toggle('hidden', cart.item_count === 0);
                });
              })
              .catch(function (error) {
                console.error('Fejl ved opdatering af cart count:', error);
              });

            // 3) åbn cart drawer (så tæt som muligt på Dawn)
            //   - prøv først et element der styrer draweren
            var drawerToggle =
              document.querySelector('[data-cart-drawer-toggle]') ||
              document.querySelector('[aria-controls="CartDrawer"]') ||
              document.querySelector('button[name="drawer-cart"]');

            if (drawerToggle) {
              drawerToggle.click();
            } else {
              // fallback: prøv at kalde renderContents på <cart-drawer>, hvis det findes
              var cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents();
              }
            }
          })
          .catch(function (error) {
            console.error('Fejl ved tilføjelse af gaveindpakning:', error);
          });
        });
      });
    });